import { Search, X, Filter } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useUrlParams } from '../hooks';
import ControlsViewMode from './controls/ControlsViewMode';
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import FiltersSidebar from './FiltersSidebar';

const TopSearchBar = () => {
  const { searchQuery, setValue, deleteValue, gender, accountStatus, certified } = useUrlParams();
  const [searchInputValue, setSearchInputValue] = useState(searchQuery || '');

  

  const handleSearch = () => {
    if (searchInputValue.trim()) {
      setValue('searchQuery', searchInputValue.trim());
    } else {
      deleteValue('searchQuery');
    }
  };

  const handleClearSearch = () => {
    setSearchInputValue('');
    deleteValue('searchQuery');
  };

  // Check if any filters are applied
  const hasActiveFilters = () => {
    return !!(gender?.length || accountStatus?.length || certified === 'true');
  };

  const getActiveFiltersCount = () => {
    let count = 0;
    if (gender?.length) count += gender.length;
    if (accountStatus?.length) count += accountStatus.length;
    if (certified === 'true') count += 1;
    return count;
  };

  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between p-4 border-b bg-background gap-4 md:gap-0">
      {/* Center: Search input - Centered on desktop */}
      <div className="flex items-center justify-center flex-1 w-full">
        <div className="flex items-center space-x-2 flex-1 max-w-full md:max-w-md">
          {/* Mobile filter button */}
          <div className="md:hidden">
            <Dialog>
              <DialogTrigger asChild>
                <Button
                  variant={hasActiveFilters() ? "default" : "outline"}
                  size="sm"
                  className="relative"
                >
                  <Filter size={16} className="mr-2" />
                  Filtres
                  {hasActiveFilters() && (
                    <Badge
                      variant="secondary"
                      className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 text-xs"
                    >
                      {getActiveFiltersCount()}
                    </Badge>
                  )}
                </Button>
              </DialogTrigger>
              <DialogContent className="max-w-md">
                <DialogHeader>
                  <DialogTitle>Filtres</DialogTitle>
                </DialogHeader>
                <FiltersSidebar />
              </DialogContent>
            </Dialog>
          </div>

          <div className="relative flex-1">
            <Input
              placeholder="Rechercher par email ou nom d'utilisateur"
              value={searchInputValue}
              onChange={(e) => setSearchInputValue(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              className="pr-8"
            />
            {searchInputValue && (
              <Button
                variant="ghost"
                size="sm"
                className="absolute right-1 top-1/2 -translate-y-1/2 h-6 w-6 p-0"
                onClick={handleClearSearch}
              >
                <X size={14} />
              </Button>
            )}
          </div>

          <Button onClick={handleSearch} size="sm">
            <Search size={16} />
          </Button>
        </div>
      </div>

      {/* Right: View switch - Hidden on mobile */}
      <div className="hidden md:flex items-center">
        <ControlsViewMode />
      </div>
    </div>
  );
};

export default TopSearchBar;
